import React  from 'react';
import * as apiAuth from "../../api/apiAuth.js"
import * as Auth from "../Login/Auth.js"

export function Logout (){
  console.log("start Logout")
  toLogout();


  function toLogout(){
    var token = Auth.getToken();
    Auth.logout();
    apiAuth.toLogout(token, (status)=>{
      window.location.href = "/";
    });
  }

  return(
    <div id="loader">
      
    </div>
  )
}